export default {
	properties: [
		{
			text: 'Nombre',
			key: 'name',
			type: 'text',
		},
	],
	singular_model_name_spanish: 'Tipo de publicacion',
	plural_model_name_spanish: 'Tipo de publicacion',
	create_model_name_spanish: 'Nuevo Tipo de publicacion',
	text_delete: 'el',
}